/**
 * Sistem ayarları servisi.
 * Firestore 'ayarlar/genel' tek dokümanında saklanır.
 *
 * Boss değiştirebilir, herkes okuyabilir.
 */

import { doc, getDoc, setDoc } from 'firebase/firestore'
import { getFirestoreDb } from '@/lib/firebase'
import { nowServer } from '@/lib/firestore'

const AYARLAR = 'ayarlar'
const GENEL = 'genel'

export interface Ayarlar {
  /** Boss puantaj tutarı (TL). Boss her +/- işleminde bu değer kullanılır. */
  puantajBossTutari: number
  /** Sorumlu puantaj tutarı (TL). Sorumlu her +/- işleminde bu değer kullanılır. */
  puantajSorumluTutari: number
}

export const VARSAYILAN_AYARLAR: Ayarlar = {
  puantajBossTutari: 500,
  puantajSorumluTutari: 200,
}

/**
 * Ayarları getir. Doküman yoksa varsayılanları döndürür.
 */
export async function ayarlariGetir(): Promise<Ayarlar> {
  const db = getFirestoreDb()
  const docRef = doc(db, AYARLAR, GENEL)
  const snap = await getDoc(docRef)
  if (!snap.exists()) return VARSAYILAN_AYARLAR

  const veri = snap.data() as Partial<Ayarlar>
  return {
    puantajBossTutari: veri.puantajBossTutari ?? VARSAYILAN_AYARLAR.puantajBossTutari,
    puantajSorumluTutari: veri.puantajSorumluTutari ?? VARSAYILAN_AYARLAR.puantajSorumluTutari,
  }
}

/**
 * Ayarları güncelle (merge ile, sadece verilen alanları yazar).
 */
export async function ayarlariGuncelle(data: Partial<Ayarlar>): Promise<void> {
  const db = getFirestoreDb()
  const docRef = doc(db, AYARLAR, GENEL)
  await setDoc(
    docRef,
    {
      ...data,
      guncellenmeTarihi: nowServer(),
    },
    { merge: true }
  )
}
